module.exports = __webpack_public_path__ + "img/p3-2-2.9a415cec.png";